<p-dialog
  [(visible)]="canShowCustomerPreviewModel"
  [contentStyle]="{ 'max-height': '50em', width: 'auto', 'z-index': '10030px' }"
  [closable]="false"
  [draggable]="false"
  showEffect="fade"
  [modal]="false"
  [style]="{ width: '80%' }"
  styleClass="preview-modal">
  <ng-template #header>
    <div class="ui-g-11">Customer Survey Response</div>
    <div
      class="ui-g-1 closesidebar diaclnav"
      (click)="closePreview()"
      (keypress.enter)="closePreview()"
      tabindex="0">
      <i class="mdl2-cancel close-icon"></i>
    </div>
  </ng-template>
  <div class="ui-g">
    <div class="ui-g-3 bg-color-1">
      <div class="mb-3">
        <div class="title">Event Id</div>
        <div>{{ custSurveyEventDetail.eventID }}</div>
      </div>
      <div class="mb-3">
        <div class="title">Workshop Type</div>
        <div class="word-wrap">{{ custSurveyEventDetail.workshopType }}</div>
      </div>
      <div class="mb-3">
        <div class="title">Partner organization</div>
        <div class="word-wrap">
          {{ custSurveyEventDetail.partnerOrganization }}
        </div>
      </div>
      <div class="mb-3">
        @if (isOneToMany) {
          <div class="title">90 Day Expiration</div>
        }
        @if (!isOneToMany) {
          <div class="title">POE Expiration Date</div>
        }
        <div>
          {{ custSurveyEventDetail.dayExpiration90 | date: 'MM/dd/yyyy' }}
        </div>
      </div>
    </div>
    <div class="ui-g-9 cust-attendee-header">
      <div class="p-grid">
        <div class="p-col-12 customer-status">
          <div class="p-col-12 p-md-8 p-lg-6">
            <div class="ui-g-4 title customer-status">Customer Status</div>
            <div class="ui-g-8">
              <p-select
                appendTo="body"
                [options]="customerStatusOptions"
                placeholder="--SELECT--"
                optionLabel="statusName"
                [(ngModel)]="selectedCustomerStatus"
                (onChange)="onStatusChange($event)">
              </p-select>
            </div>
          </div>
        </div>
        <div class="p-col-12 p-md-8 p-lg-6">
          <div class="ui-g-4 title">Customer</div>
          <div class="ui-g-8">
            <p-select
              appendTo="body"
              [options]="eventCustomers"
              placeholder="--SELECT--"
              optionLabel="customerName"
              [(ngModel)]="selectedEventCustomer"
              (onChange)="onCustomerChange($event)">
            </p-select>
          </div>
        </div>
        <div class="p-col-12 p-md-8 p-lg-6">
          <div class="ui-g-4 title">Attendee</div>
          <div class="ui-g-8">
            <p-select
              appendTo="body"
              [options]="eventAttendees"
              placeholder="--SELECT--"
              optionLabel="attendeeName"
              [(ngModel)]="selectedEventCustomerAttendee"
              (onChange)="onAttendeeChange($event)">
            </p-select>
          </div>
        </div>
      </div>

      <div class="ui-g scroll-bar" style="padding-top: 40px !important">
        <div class="bgtd restablebdr ui-g-12">
          <table class="restable" cellpadding="0" cellspacing="0">
            <tr>
              <th style="width: 55px">Ques#</th>
              <th>Questions</th>
              <th>Response</th>
            </tr>
            @if (isSurveyResponseload) {
              <tr>
                <td colspan="3">
                  <div class="btnloader"></div>
                </td>
              </tr>
            }
            <ng-template ngFor let-response [ngForOf]="customerAttendeeSurveys">
              <tr>
                <td>{{ response.questionSequenceOrder }}</td>
                <td>{{ response.question }}</td>
                <td>{{ response.answer }}</td>
              </tr>
            </ng-template>
          </table>
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-g">
          <div class="ui-g-1"></div>
          <div class="ui-g-10">
            @for (message of msgsUsageDetails; track message) {
              <p-message [life]="3000" [text]="message.detail"></p-message>
            }
          </div>
          <div class="ui-g-1"></div>
          <div class="ui-g-1"></div>
          <div class="ui-g-1">
            <input
              class="next-previous"
              type="button"
              value="« Previous"
              [disabled]="!checkForPrevious()"
              (click)="onPreviousClick()" />
          </div>
          <div class="ui-g-8 center">
            @if (!isCustomerSurveyPreviewLoading) {
              <div>
                <button
                  type="button"
                  pButton
                  pTooltip="Reject"
                  tooltipPosition="top"
                  [disabled]="IsCustomerSurveyRejected()"
                  class="ui-button-info btnpad btnmr button-deny"
                  (click)="onDenyOpen()">
                  Reject
                </button>
                <button
                  type="button"
                  pButton
                  pTooltip="Approve"
                  tooltipPosition="top"
                  [disabled]="IsCustomerSurveyApproved()"
                  class="ui-button-info btnpad btnmr button-approve"
                  (click)="submitForApproval()">
                  Approve
                </button>
              </div>
            }
          </div>
          <div class="ui-g-2">
            <input
              class="next-previous"
              type="button"
              value="Next »"
              [disabled]="!checkForNext()"
              (click)="onNextClick()" />
          </div>
        </div>
      </div>
    </div>
  </div>

  <p-dialog
    [(visible)]="canShowRejectionModalDisplay"
    [contentStyle]="{
      'max-height': '50em',
      width: 'auto',
      'z-index': '1038px'
    }"
    [closable]="false"
    [draggable]="false"
    showEffect="fade"
    [modal]="false"
    class="modal-position">
    <ng-template #header>
      <div class="ui-g-11">
        <span>Select reasons to reject</span>
      </div>
      <div
        class="ui-g-1 closesidebar diaclnav"
        (click)="closeDeclineModal()"
        (keydown.enter)="closeDeclineModal()"
        tabindex="0">
        <i class="mdl2-cancel close-icon"></i>
      </div>
    </ng-template>
    <form [formGroup]="formCustomerSurveyRejection">
      <div class="mb-3">
        <div class="title">Reasons</div>
        <p-select
          appendTo="body"
          [options]="rejectionReason"
          placeholder="--SELECT--"
          optionLabel="rejectReasonDescription"
          formControlName="rejectionReason"></p-select>
      </div>
      <button
        type="button"
        pTooltip="Ok"
        tooltipPosition="top"
        [disabled]="!customerDenyButtonEnable"
        class="ui-button-info btnpad btnmr button-ok"
        pButton
        (click)="onDeny()">
        Ok
      </button>
      <button
        type="button"
        pTooltip="Cancel"
        tooltipPosition="top"
        class="ui-button-info btnpad btnmr button-cancel"
        pButton
        (click)="closeDeclineModal()">
        Cancel
      </button>
    </form>
  </p-dialog>

  @if (isApproveReject) {
    <div class="loading-indicator">
      <p-progressSpinner></p-progressSpinner>
    </div>
  }
</p-dialog>
